module.exports = __webpack_public_path__ + "static/media/31.cb90e1d5.jpg";